<template>
  <div class="select_box">
    <div
      class="select"
      @click="handleSelectClick"
      v-click-outside="hideSelectList"
      :class="{
        disabled: selectDisabled,
      }"
    >
      <div class="selected">
        <svg
          class="item_svg"
          :class="{
            happy_icon: selected.icon.id === '#happy',
          }"
        >
          <use :xlink:href="`${selected.icon.source}${selected.icon.id}`" />
        </svg>

        <span>{{ selected.type }}</span>
      </div>

      <div class="icon">
        <svg class="select_svg" :class="{ isOpen: isOpen }">
          <use xlink:href="../../assets/icons/arrow-down.svg#arrow-down" />
        </svg>
      </div>
    </div>

    <ul class="items_list" v-show="isOpen">
      <li
        class="item"
        v-if="item.type !== selected.type"
        v-for="item of currentItems"
        @click="handleItemClick(item)"
      >
        <svg
          class="item_svg"
          :class="{
            happy_icon: item.icon.id === '#happy',
          }"
        >
          <use :xlink:href="`${item.icon.source}${item.icon.id}`" />
        </svg>

        <span> {{ item.type }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      selected: this.$props.items[0],
      isOpen: false,
    };
  },
  computed: {
    currentItems() {
      return this.$props.items;
    },

    selectDisabled() {
      return this.$props.disabled;
    },
  },
  methods: {
    handleSelectClick() {
      if (!this.selectDisabled) {
        this.isOpen = !this.isOpen;
      }
    },

    hideSelectList() {
      this.isOpen = false;
    },

    handleItemClick(item) {
      this.selected = item;
      this.isOpen = false;
      this.$emit("onSelect", item.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.select_box {
  position: relative;
  color: #333;
  font-family: Inter;
}

.select {
  width: 231px;
  padding: 6px 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  background: #f2f2f2;
  cursor: pointer;

  @media screen and (max-width: 940px) {
    width: 100%;
  }
}

.disabled {
  cursor: default;
  opacity: 0.5;
}

.select_svg {
  width: 14px;
  height: 8px;
  stroke: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms linear;

  &.isOpen {
    transform: rotate(180deg);
  }
}

.selected {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.items_list {
  margin: 0;
  padding: 16px 0;
  position: absolute;
  left: 0%;
  top: calc(100% + 4px);
  width: 100%;
  list-style: none;
  overflow: hidden;
  z-index: 998;

  border-radius: 8px;
  border: 1px solid #e3e8ef;
  background: #fff;
}

.item {
  width: 100%;
  padding: 6px 16px;
  cursor: pointer;
  transition: all ease-in-out 300ms;
  display: flex;
  fill: #333;
  gap: 12px;
  color: #828282;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  z-index: 999;

  &:hover {
    background-color: #f2f2f2;
  }
}

.item_svg {
  width: 24px;
  height: 24px;
  fill: #828282;
}

.happy_icon {
  fill: #2f80ed;
}
</style>
